import { Dispatch, SetStateAction, createContext } from 'react';
import { Chessviewer } from '../utils/Chessviewer';
import { GameModel, GameMoveModel } from '../types/GamesModel';
import { Platform } from '../types/Platform';

export type GameContextType = {
  currentMove?: GameMoveModel;
  setCurrentMove: Dispatch<SetStateAction<GameMoveModel | undefined>>;
  game: GameModel;
  chessviewerRef: React.MutableRefObject<Chessviewer | undefined>;
  // The side shown at the bottom of the board. Shared so the docked panel's mini board and its
  // win-chance readout follow the main board (including flips), and are read from the viewer's
  // perspective rather than the side that happened to move.
  orientation: 'white' | 'black';
  flip: () => void;
  // Live engine result (White's win chance 0–100) for a manually dragged position on the main board.
  // Null during normal game playback; set while exploring so the eval bar reflects the local engine
  // instead of the stored move evaluation. See GamesListItemChessboard.
  analysisWhiteWin: number | null;
  setAnalysisWhiteWin: (value: number | null) => void;
  // Whether piece dragging / exploration mode is on. Mirrors Chessviewer's own flag so the toggle
  // button and best-line taps stay in sync (Chessviewer can turn it off itself when a game move is
  // selected).
  dragging: boolean;
  setDragging: (value: boolean) => void;
};

export default createContext<GameContextType>({
  currentMove: undefined,
  setCurrentMove: () => {},
  game: {
    Id: 0,
    Date: '',
    White: '',
    Black: '',
    WhiteElo: '',
    BlackElo: '',
    Result: '',
    ECOUrl: '',
    Opening: '',
    Termination: '',
    TimeControl: '',
    Link: '',
    Pgn: '',
    Platform: Platform.ChessCom,
    Moves: [],
    PublicCommentCount: 0,
    FavoriteMovePgns: [],
    MoveCount: 0,
    MoveTotal: 0,
    Starred: false,
  },
  chessviewerRef: { current: undefined },
  orientation: 'white',
  flip: () => {},
  analysisWhiteWin: null,
  setAnalysisWhiteWin: () => {},
  dragging: false,
  setDragging: () => {},
});
